import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options, label }) {
    return (
        <div className="ns-relative">
            <select
                className={`ns-selection-dropdown-menu ns-text-align-left ${className}`}
                value={value}
                onChange={onChange}
                aria-label={label || "Select"}
            >
                {options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            <svg class="icon-chevron-down-small " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none"><title>Chevron down icon</title><path class="icon-chevron-down-left" d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path><path class="icon-chevron-down-right" d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path></svg>
        </div>
    )
}
